import { Directive, HostListener, Input } from '@angular/core';
import { Status } from '@df/core/status';
import { DfModalService } from '@df/ui/modal/df-modal.service';

@Directive({
    standalone: false,
    selector: '[iCmsModalOpen]'
})
export class ICmsModalOpenDirective<T = any> {
    /**
     * REQUIRED
     * Input for cms modal id to open
     */
    @Input()
    iCmsModalOpen!: string | false;

    @Input()
    iCmsModalVariant?: string;

    @Input()
    iCmsModalOpenData?: T;

    /**
     * If provided we will use it
     */
    @Input()
    status?: Status;

    /**
     * Clieck event handling
     */
    @HostListener('click')
    protected onClick(): void {
        this._onClick();
    }

    protected _onClick(): void {
        if (this.iCmsModalOpen) {
            this.dfModalService.open(this.status, this.iCmsModalOpen, this.iCmsModalVariant, this.iCmsModalOpenData);
        }
    }

    /**
     * Class constructer
     */
    constructor(private dfModalService: DfModalService) {}
}
